import React, { Component } from 'react';
import { SynapseFiLogo } from './data/SynapseFiLogo';
import styled from 'styled-components';

const LogoContainer = styled.div`
    display: flex;
    align-items: center;
    width: min-content;

    &:hover {
        cursor: pointer
    }

    a {
        font-size: 0px;
    }
`;

const HeaderBar = styled.div`
    background-color: #000;
    width: 100%;
    box-sizing: border-box;
    padding: 10px 20px;
    color: #fff;
    display: grid;
    grid-template-columns: 1fr 2fr 1fr;
    position: relative;
    align-items: center;
    z-index: 3000;
    grid-area: header;
`;

class Header extends Component {
    render() {
        return (
            <React.Fragment>
                <HeaderBar>
                    <LogoContainer>
                        <a href="https://synapsefi.com/"  target="_blank">
                            <SynapseFiLogo />
                        </a>
                    </LogoContainer>
                </HeaderBar>
            </React.Fragment>
        );
    };
}

export default Header;